// import { TitulationPaymentInfo } from '../p/types';
import { ColumnTable, Button } from '@octano/global-ui';
import BadgeState from '../parts/BadgeState';
import { moneyFormatter } from '../../../../../utils/currency';
import { PaymentInfo } from '../../../types';

export function useColumns(texts: {
  noResults: string;
  headers: {
    concept: string;
    amount: string;
    paymentDate: string;
    status: string;
    action: string;
  };
  values: {
    concept: string;
    button: string;
    payment: {
      pending: string;
      paid: string;
    };
  };
}): Array<ColumnTable<PaymentInfo>> {
  return [
    {
      columnName: 'concept',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.headers.concept,
      width: '15%',
      cellFormat: () => <div>{texts.values.concept}</div>,
    },
    {
      columnName: 'amount',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.headers.amount,
      cellFormat: ({ row }) => {
        return <div>{moneyFormatter().format(row.amount)}</div>;
      },
    },
    {
      columnName: 'paymentDate',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.headers.paymentDate,
      cellFormat: ({ row }) => {
        return row.paymentDate && <div>{row.paymentDate}</div>;
      },
    },
    {
      columnName: 'status',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.headers.status,
      cellFormat: ({ row }) => {
        if (row.status === 'paid') {
          return (
            <BadgeState status="approved" text={texts.values.payment.paid} />
          );
        }
        return (
          <BadgeState status="pending" text={texts.values.payment.pending} />
        );
      },
    },
    {
      columnName: 'action',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.headers.action,
      width: '15%',
      cellFormat: ({ row }) => (
        <Button
          disabled
          size="sm"
          fullwidth
          text={texts.values.button}
          onClick={() => console.log(row)}
        />
      ),
    },
  ];
}
